import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";

/**
 * Single export entry point: user picks CSV or XLSX in a modal.
 */
const ExportFormatDialog = ({
  open,
  onClose,
  onExport,
  exporting = false,
  title = "Export",
  description = "Choose the file format for your export.",
  defaultFormat = "xlsx",
}) => {
  const [format, setFormat] = useState(defaultFormat);

  useEffect(() => {
    if (open) {
      setFormat(defaultFormat);
    }
  }, [open, defaultFormat]);

  const handleExport = () => {
    if (typeof onExport === "function") {
      onExport(format);
    }
  };

  return (
    <Dialog open={open} onClose={exporting ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
          {description}
        </Typography>
        <FormControl component="fieldset" disabled={exporting}>
          <RadioGroup
            value={format}
            onChange={(e) => setFormat(e.target.value)}
            name="export-format"
          >
            <FormControlLabel
              value="xlsx"
              control={<Radio color="primary" />}
              label="Excel (.xlsx)"
            />
            <FormControlLabel
              value="csv"
              control={<Radio color="primary" />}
              label="CSV (.csv)"
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={exporting}>
          Cancel
        </Button>
        <Button
          onClick={handleExport}
          color="primary"
          variant="contained"
          disabled={exporting}
          style={{ backgroundColor: exporting ? undefined : "#1565c0", color: "#fff" }}
        >
          {exporting ? "Exporting..." : "Export"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportFormatDialog;
